import React, { useState } from 'react';
import moment from 'moment';
import parser from 'cron-parser';
import voca from 'voca';
import { getKeyOfFrequnecy } from '../../common/utils/schedule-utils';
import StatsTable from './StatsTable';

const ShowTaskDetail = ({ taskDetail }) => {
  let expression = '0 0 */1 * *';
  if (taskDetail.interval) {
    expression = taskDetail.interval;
  }
  const exParser = parser.parseExpression(expression);
  const [interval, setinterval] = useState(exParser);

  const showTaskStats = () => {
    if (taskDetail.stats) {
      return (
        <table className="table table-responsinve table-bordered table-stripped table-hover">
          <thead>
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {taskDetail.stats.map((stat) => (
              <StatsTable key={stat.uuid} stat={stat} />
            ))}
          </tbody>
        </table>
      );
    } else {
      return '';
    }
  };
  return (
    <>
      <table className="table table-responsinve table-bordered table-stripped table-hover">
        <tbody>
          <tr>
            <th>Name</th>
            <td>{taskDetail.name}</td>
          </tr>
          <tr>
            <th>Frequency</th>
            <td>{getKeyOfFrequnecy(taskDetail.interval)}</td>
          </tr>
          <tr>
            <th>Next Execution</th>
            <td>{moment(interval.next().toString()).fromNow()}</td>
          </tr>
          <tr>
            <th>Type</th>
            <td>{voca.replaceAll(voca.titleCase(taskDetail.taskType), '_', ' ')}</td>
          </tr>
        </tbody>
      </table>
      <div className="row">
        <div className="col-md-12 col-lg-12 col-sm-12">{showTaskStats()}</div>
      </div>
    </>
  );
};

export default ShowTaskDetail;
